import React, { useEffect, useState, createContext, useContext } from 'react';
import TokenService from '../Services/Token.service';
import { 
  setIdleCallback, 
  startIdleDetection, 
  stopIdleDetection 
} from '../Utils/IdleUtils';

const IdleContext = createContext(false); // Default to false (not idle)

export const useIdleStatus = () => useContext(IdleContext); // Custom hook to access idle status

const IdleProvider = ({ children, idleTimeout = 3600000 }) => {
  const [isIdle, setIsIdle] = useState(() => {
    // Initialize from local storage if exists
    const storedStatus = TokenService.getUserIdle();
    return storedStatus === 'true'; // Parse as boolean
  });

  useEffect(() => {
    const handleIdle = (idleStatus) => {
      setIsIdle(idleStatus);
      TokenService.setUserIdle(idleStatus);
    };

    setIdleCallback(handleIdle);
    startIdleDetection(idleTimeout);

    return () => stopIdleDetection(); // Cleanup on unmount
  }, [idleTimeout]);

  const resetIdleStatus = () => {
    setIsIdle(false); // Reset idle status
    TokenService.setUserIdle(false);
  };

  return (
    <IdleContext.Provider value={{ isIdle, resetIdleStatus }}>
      {children}
    </IdleContext.Provider>
  );
};

export default IdleProvider;